export default __webpack_public_path__ + "static/media/tb-team-victor.d2a075ce.gif";